import {FilterType, FilterValue} from "../../../../types/filter";
import {useCallback, useMemo, useState} from "react";
import {PageSearchCondition} from "../../../../types/page";
import {useListSearchParams} from "../../../../hooks/list/useListSearchParams";
import {
    CounselorHistoryFilterValues,
    CounselorHistoryFilterWordType,
    CounselorHistoryListQueryType,
} from "../../../../types/counselor";
import {useFilterValues} from "../../../../hooks/list/useFilterValues";
import {TestType} from "../../../../types/common";
import {AdminStatus} from "../../../../types/admin";

export function useCounselorHistoryFilterValues() {

    const [queryType, setQueryType] = useState('');
    const [query, setQuery] = useState("");
    const [createdAt, setCreatedAt] = useState<Date | undefined>();
    const [createdTo, setCreatedTo] = useState<Date | undefined>();
    const [desiredAt, setDesiredAt] = useState<Date | undefined>();
    const [desiredTo, setDesiredTo] = useState<Date | undefined>();
    const [testType, setTestType] = useState('')
    const [status, setStatus] = useState(''); // 상담 상태
    const [pageInfoOnFilter, setPageInfoOnFilter] = useState<PageSearchCondition>({});

    const { listQueryType, setUrlSearchParams } = useListSearchParams<CounselorHistoryListQueryType>();

    // 필터 영역
    const filterValueArray: FilterValue<any>[] = useMemo(
        () => [
            {
                key: "queryType",
                value: queryType,
                setter: setQueryType,
                defaultValue: '',
                type: FilterType.OTHER,
            },
            {key: "query", value: query, setter: setQuery, defaultValue: undefined, type: FilterType.STRING},
            {
                key: "createdAt",
                value: createdAt,
                setter: setCreatedAt,
                defaultValue: undefined,
                type: FilterType.DATE,
            },
            {
                key: "createdTo",
                value: createdTo,
                setter: setCreatedTo,
                defaultValue: undefined,
                type: FilterType.DATE,
            },
            {
                key: "desiredAt",
                value: desiredAt,
                setter: setDesiredAt,
                defaultValue: undefined,
                type: FilterType.DATE,
            },
            {
                key: "desiredTo",
                value: desiredTo,
                setter: setDesiredTo,
                defaultValue: undefined,
                type: FilterType.DATE,
            },
            {
                key: "testType",
                value: testType,
                setter: setTestType,
                defaultValue: '',
                type: FilterType.OTHER,
            },
            {
                key: "status",
                value: status,
                setter: setStatus,
                defaultValue: '',
                type: FilterType.OTHER,
            },
        ],
        [query, queryType, createdAt, createdTo, desiredAt, desiredTo, testType, status]
    );

    const { getFilterValueByKey } = useFilterValues({
        filterValueArray,
        listQueryType: listQueryType,
        setPageInfoOnFilter,
    });

    const filterValues = useMemo(
        () =>
            ({
                queryFilterValue: getFilterValueByKey("query") as FilterValue<string>,
                queryTypeFilterValue: getFilterValueByKey("queryType") as FilterValue<CounselorHistoryFilterWordType>,
                createdAtFilterValue: getFilterValueByKey("createdAt") as FilterValue<Date | undefined>,
                createdToFilterValue: getFilterValueByKey("createdTo") as FilterValue<Date | undefined>,
                desiredAtFilterValue: getFilterValueByKey("desiredAt") as FilterValue<Date | undefined>,
                desiredToFilterValue: getFilterValueByKey("desiredTo") as FilterValue<Date | undefined>,
                testTypeFilterValue: getFilterValueByKey("testType") as FilterValue<TestType>,
                statusFilterValue: getFilterValueByKey("status") as FilterValue<AdminStatus>,
            } as CounselorHistoryFilterValues),
        [getFilterValueByKey]
    );
    // 필터 영역 종료


    // searchList 영역
    const searchList = useCallback(
        (pageSearchCondition: PageSearchCondition, listQueryTypeParam?: CounselorHistoryListQueryType) => {
            const param: CounselorHistoryListQueryType = {
                query: listQueryTypeParam?.query,
                queryType: listQueryTypeParam?.queryType,
                createdAt: listQueryTypeParam?.createdAt,
                createdTo: listQueryTypeParam?.createdTo,
                desiredAt: listQueryTypeParam?.desiredAt,
                desiredTo: listQueryTypeParam?.desiredTo,
                testType: listQueryTypeParam?.testType,
                status: listQueryTypeParam?.status,
            };

            return () => setUrlSearchParams(param, pageSearchCondition);
        },
        [setUrlSearchParams]
    );

    return{
        pageInfoOnFilter,
        filterValues, searchList,
        listQueryType
    }
}